module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAATlBMVEUAAAAAc8kAc8gAc8gAcskAccoAcskAcskAc8gAcskAc8gAcsoAccsAccoAc8gAc8cAc8gAcsgAc8gAccwAcskAcssAc8gAccoAcsoAc8hMSHkQAAAAGXRSTlMA79/DnTIuHePPuWRMGvTbzaGDenFfWE88ewJCtwAAAE9JREFUCNcNy1cSg0AQA9FmgxcDzgH6/hdF72NqqiTx9+6LtRNNF67+INfKKF74un8ecLNRhQOYCk+JvDNvN6LbUsqAMdlh07noSoxFa5IT4kYD4ytXbJsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_bgFreshen.png
// module id = oqaC
// module chunks = 9